<template>
  <font-awesome-icon
    icon="address-book"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAddressBook } from '@fortawesome/free-solid-svg-icons'

library.add(faAddressBook)

export default {
  name: 'CoozzyAddressBookIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
